export const misDistReportConfig = {
  colKey1: "",
  colKey2: "",
  colKey3: "reported_on",
  colKey4: "distName",
  colKey5: "blockName",
  colKey6: "nameOfDisaster",
  colKey7: "incidentId",
  colKey8: "incidentAddress",
  colKey9: "latitude",
  colKey10: "longitude",
  colKey11: "typeOfCasualty",
  colKey12: "personName",
  colKey13: "personFamilyMemberName",
  colKey14: "age",
  colKey15: "gender",
  colKey16: "personAddress",
  colKey17: "activityDuringAccident", // This was colKey16, now colKey17
  colKey18: "isPostMortem",           // This was colKey17, now colKey18
  colKey19: "occupation",             // This was colKey18, now colKey19
  colKey20: "heatStrokeCertified",    // This was colKey19, now colKey20
  colKey21: "isHospitalized",         // This was colKey20, now colKey21
  colKey22: "hospitalName",           // This was colKey21, now colKey22
  colKey23: "isReportedToPS",         // This was colKey22, now colKey23
  colKey24: "policeStationName",      // This was colKey23, now colKey24
  colKey25: "remarks",                // This was colKey24, now colKey25
  colKey26: "entryDate",              // This was colKey25, now colKey26
  colKey27: "paymentStatus",          // This was colKey26, now colKey27
  colKey28: "paymentDate",            // This was colKey27, now colKey28
};

export const misColumns = Object.entries(misDistReportConfig).map(
  ([key, value], index) => ({
    Header: `misdisthumanlossreport.headercol${index + 1}`,
    accessor: value,
    disableSortBy: true,
    showInitially: true,
  })
);
